import { initializeLogger } from '@seamless/logger';
import { initializeStore } from '@seamless/store';

export const logger = initializeLogger('mmcs-consents-management-store');
export const seamlessStore = initializeStore();
